import {defineStore} from "pinia";

const BACK_URL =import.meta.env.VITE_API_URL || "http://127.0.0.1:8000"

export const useAppStore = defineStore('app', {
    state: () => ({
        count: 0,
        ApiUrl: BACK_URL + "/api",
        AdminUrl: BACK_URL + "/admin",
    }),
    getters: {
        doubleCount: (state) => state.count * 2,
    },
    actions: {
        increment() {
            this.count++
        },
    },
})